<template>
  <span>
    <strong
      :class="['status cursor-pointer', `is-${statusToClassName}`]"
      :name="`customer-transaction-details-tippy-${transactionId}-${anotherKey}`"
    >
      {{ $t(`status.${getStatus}`) }}
    </strong>
    <div class="tooltip-content">
      <TippyContent
        :to="`customer-transaction-details-tippy-${transactionId}-${anotherKey}`"
        placement="left"
      >
        <div class="p-2 text-xs text">
          <div
            v-for="(transaction, index) in transactions"
            :key="`customer-transaction-details-${transactionId}-item-${transaction.id}`"
          >
            <hr v-if="index > 0" class="my-3" />
            <div class="w-60">
              <div class="flex justify-between">
                <p class="text-left">{{ transaction.transactionDate }}</p>
              </div>
              <div class="flex justify-between mt-2">
                <p class="text-left">{{ transaction.activeAccount }}</p>
              </div>
              <div class="flex justify-between mt-2">
                <p class="text-left">{{ transaction.passiveAccount }}</p>
              </div>
              <div class="flex justify-between mt-2">
                <p class="text-left">{{ transaction.amount | currency }}</p>
              </div>
              <div class="flex justify-between mt-2">
                <p class="text-left">{{ transaction.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </TippyContent>
    </div>
  </span>
</template>

<script>
import TippyContent from '@/components/ui/TippyContent';
import humps from 'humps';

export default {
  props: {
    transactionId: Number,
    transactionStatus: String,
    transactions: Array,
    anotherKey: Number,
  },
  components: {
    TippyContent,
  },
  computed: {
    statusToClassName() {
      return this.transactionStatus ? this.transactionStatus.replace('_', '-').toLowerCase() : '';
    },
    getStatus() {
      return this.transactionStatus ? humps.camelize(this.transactionStatus.toLowerCase()) : '';
    },
  },
};
</script>
